module.exports = __webpack_public_path__ + "public/images/writing.6f808a5423d7a02a918f55c67188ce6b.png";